import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Input,
  InputNumber,
  Form,
  Select,
  DatePicker,
  Row,
  Col,
  Spin,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";
import { toast } from "react-toastify";
import moment from "moment";
import UserIcon from "../../../../assets/images/icons/userLogo.svg";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useStore } from "../../../../store";
import { TAB_KEYS, dateFormat, dateTimeFormat } from "../../../../config";
import { useTab } from "../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../utils";
import ImageLabel from "../../../image-label";
import { formatData } from "../../../../utils/formatData";
import { setUpdatedValues } from "../../../../store/actions";
import ReactPlayer from "react-player/youtube";
import SynthesiaVideo from "./SynthesiaVideo";

const { TextArea } = Input;
const MAX_CHARACTERS = 250;

export default function ContractComponent({ dataLoader, form }) {
  const params = useParams();
  const { state } = useLocation();

  const tabKey = state;
  const { tabData } = useStore();
  const whichTab = TAB_KEYS.contract;
  const { deleteSingleItem, postLoader, callMicroServices } = useTab();
  const { updateImage } = useConnectsuForm();
  const [loader, setLoader] = useState(true);
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues, dispatch } = useStore();
  const navigate = useNavigate();

  // 🔹 New states for Add/Clear handling
  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);

  useEffect(() => {
    localStorage.setItem("tab", "CONTRACT");
    console.log('tabData', tabData);
  }, []);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  }, [Object.keys(updatedValues).length]);

  const validatePostalCode = (value) => {
    const ukPostalCodeRegex = /^[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}$/;
    if (ukPostalCodeRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject();
  };

  const renderMedia = (dataItem) => {
    const commonStyles = {
      width: "350px",
      height: "250px",
      display: "flex",
      justifyContent: "center",
    };

    if (
      dataItem?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className="iframe-comp" style={commonStyles}>
          <ReactPlayer
            controls={true}
            url={dataItem.mediaLink.url}
            width="100%"
            height="100%"
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div style={commonStyles}>
          <iframe
            src={dataItem.mediaLink.url}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            width="100%"
            height="100%"
            style={{ backgroundColor: "black" }}
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "IMAGE" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className="iframe-comp" style={commonStyles}>
          <img
            src={dataItem?.mediaLink?.url}
            alt=""
            className="c1 carousel-image"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      );
    }

    else if (
      dataItem?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
      dataItem.mediaLink.url) {
      return (
        <div>
          <SynthesiaVideo key={dataItem.id} videoData={dataItem} />

        </div>
      )
    }


    return null;
  };

  const findValue = (i, key) => {
    return getFormFieldValue(form, whichTab, i, key);
  };
  const SelectChangeHandler = (e, i) => {
    form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
  };
  useEffect(() => {
    form.resetFields();
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [tabData[whichTab]]);

  const submit = (info) => {
    const formattedData = formatData(
      "contract",
      info["contract"],
      updatedValues,
      localStorage.getItem("selectedTabId")
    );
    if (Object.keys(formattedData).length > 0) {
      dispatch(setUpdatedValues({}));
      callMicroServices("contract", formattedData, form);
    } else {
      toast.error("Nothing to update");
    }
  };


  // ✅ Empty contract row template
  const emptyRow = {
    id: undefined,
    title: "",
    procurementReference: "",
    description: "",
    postalCode: "", // Make sure this exists and is empty string, not null/undefined
    valueOfContract: null,
    startDate: null,
    endDate: null,
    closeDate: null,
    closeTime: null,
    contractType: "",
    webLink: "",
    email: "",
    mediaLink: { mediaType: undefined, url: "" },
    media: null,
  };

  // ✅ Handle Add More
  const handleAddMore = () => {
    if (!canAddNew) {
      toast.warning("You must save or clear the current item before adding a new one.");
      return;
    }
    const currentList = form.getFieldValue(whichTab) || [];
    const newList = [emptyRow, ...currentList];
    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Handle Clear
  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const updatedList = currentList.map(item => (!item?.id ? { ...emptyRow } : item));
    form.setFieldsValue({ [whichTab]: updatedList });

    // refreshUnsavedState();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabData?.contract?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer); // cleanup for safety
  }, [tabData?.contract]);

  // ✅ Refresh Unsaved State
  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(item => {
      const hasData =
        item?.title?.trim() ||
        item?.description?.trim() ||
        item?.postalCode?.trim() ||
        item?.contractType?.trim() ||
        item?.mediaLink?.url?.trim() ||
        item?.media ||
        item?.valueOfContract ||
        item?.email?.trim();
      return !item?.id && hasData;
    });

    setCanAddNew(!unsavedItem);
    setHasUnsavedItem(!!unsavedItem);
  };

  // ✅ Call refreshUnsavedState on every form change
  useEffect(() => {
    const unsubscribe = form.subscribe?.(() => refreshUnsavedState());
    return () => unsubscribe?.();
  }, [form]);

  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div>
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {tabKey === whichTab ? (
            <>
              <Col className="gutter-row tabContent" span={24}>
                <>
                  <Form.List
                    name={whichTab}
                    initialValue={
                      tabData &&
                        tabData[whichTab] &&
                        tabData[whichTab].length > 0
                        ? tabData[whichTab].map((item) => ({
                          ...item,
                          // Ensure postalCode is properly included
                          postalCode: item.postalCode || "",
                          // Convert date strings to moment objects if needed
                          startDate: item?.startDate
                            ? moment(item.startDate)
                            : null,
                          endDate: item?.endDate
                            ? moment(item.endDate)
                            : null,
                          closeDate: item?.closeDate
                            ? moment(item.closeDate)
                            : null,
                          closeTime: item?.closeTime
                            ? moment(item.closeTime)
                            : null,
                        }))
                        : [emptyRow]
                    }
                  >
                    {(fields, { add, remove }) => (
                      <>
                        <div className="inputBody">
                          <label></label>
                          <div style={{ textAlign: "right" }}>
                            {hasUnsavedItem && (
                              <Button
                                className="cancelBtn"
                                type="button"
                                onClick={handleClear}
                              >
                                Clear
                              </Button>
                            )}
                            <Button
                              className="greenBtn"
                              onClick={handleAddMore}
                            >
                              Add <PlusOutlined />
                            </Button>
                          </div>
                        </div>
                        {fields.map(({ key, name, ...restField }, i) => {
                          const currentPostalCode = form.getFieldValue([
                            whichTab,
                            i,
                            "postalCode",
                          ]);
                          console.log(
                            `PostalCode for item ${i}:`,
                            currentPostalCode
                          );
                          return (
                            <div className="card-item">
                              <Col
                                className="gutter-row tabContent"
                                span={16}
                                style={{ paddingRight: "25px" }}
                              >
                                <div className="d-flex">
                                  <Form.Item
                                    {...restField}
                                    label="Contract Title"
                                    className="w-100"
                                    name={[name, "title"]}
                                    labelCol={{ span: 6 }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Contract Title is required",
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder="Contract Title"
                                      maxLength={40}
                                      showCount={{
                                        formatter: ({ count }) => `${count}/40`,
                                      }}
                                    
                                      onKeyDown={(e) => {
                                        const currentValue =
                                          form.getFieldValue([whichTab, name, "title"]) || "";

                                        if (
                                          e.key.length === 1 && // normal characters only
                                          currentValue.length >= 40
                                        ) {
                                          form.setFields([
                                            {
                                              name: [whichTab, name, "title"],
                                              errors: ["Title cannot exceed 40 characters"],
                                            },
                                          ]);
                                        }
                                      }}
                                      onBlur={() => {
                                        form.setFields([
                                          {
                                            name: [whichTab, name, "title"],
                                            errors: [],
                                          },
                                        ]);
                                      }}
                                    />
                                  </Form.Item>

                                  <Form.Item>
                                    <div className="remove-btn">
                                      <DeleteOutlined
                                        onClick={() => {
                                          const id = form.getFieldValue([
                                            whichTab,
                                            i,
                                            "id",
                                          ]);
                                          if (id) {
                                            // Existing saved record → call delete API
                                            deleteSingleItem(
                                              whichTab,
                                              id,
                                              form
                                            );
                                          } else {
                                            // Newly added unsaved record → just remove from form list
                                            remove(name);
                                            setHasUnsavedItem(false);
                                            refreshUnsavedState();
                                          }
                                        }}
                                      />
                                    </div>
                                  </Form.Item>
                                </div>
                                <Form.Item
                                  {...restField}
                                  className="w-100"
                                  label="Procurement Reference"
                                  name={[name, "procurementReference"]}
                                  labelCol={{ span: 6 }}
                                >
                                  <Input placeholder="Procurement Reference" />
                                </Form.Item>
                                <Form.Item
                                  label="Description"
                                  {...restField}
                                  name={[name, "description"]}
                                  labelCol={{ span: 6 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Description is required",
                                    },
                                    {
                                      max: MAX_CHARACTERS - 1,
                                      message: `Description should be less than ${MAX_CHARACTERS} character`,
                                    },
                                  ]}
                                >
                                  <TextArea
                                    placeholder="Enter Description"
                                    showCount
                                    rows={5}
                                    maxLength={MAX_CHARACTERS}
                                  />
                                </Form.Item>
                                <Form.Item
                                  {...restField}
                                  label="Postal code"
                                  name={[name, "postalCode"]}
                                  labelCol={{ span: 6 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Postal code is required",
                                    },
                                    {
                                      validator: (_, value) => {
                                        console.log(
                                          "Validating postal code:",
                                          value
                                        );
                                        if (!value) return Promise.resolve();
                                        const ukPostalCodeRegex =
                                          /^[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}$/i;
                                        const isValid =
                                          ukPostalCodeRegex.test(value);
                                        console.log(
                                          "Postal code validation result:",
                                          isValid
                                        );
                                        return isValid
                                          ? Promise.resolve()
                                          : Promise.reject(
                                            "Please enter a valid postal code"
                                          );
                                      },
                                    },
                                  ]}
                                >
                                  <div className="d-flex align-items-center">
                                    <Input
                                      className="addressBox custom-placeholder"
                                      rows={1}
                                      placeholder="Postal code"
                                      maxLength={50}
                                      value={currentPostalCode} // Explicitly set value
                                      onChange={(e) => {
                                        console.log(
                                          "Postal code changed:",
                                          e.target.value
                                        );
                                        form.setFieldValue(
                                          [whichTab, i, "postalCode"],
                                          e.target.value
                                        );
                                      }}
                                    />
                                    <Tooltip title="Provide UK postal codes">
                                      <ExclamationCircleOutlined
                                        style={{
                                          marginLeft: 8,
                                          fontSize: "20px",
                                          color: "#3067ae",
                                          position: "absolute",
                                          right: "-25px",
                                          top: "5px",
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </Form.Item>
                                <Form.Item
                                  {...restField}
                                  label="Value Of Contract"
                                  name={[name, "valueOfContract"]}
                                  labelCol={{ span: 6 }}
                                  rules={[
                                    {
                                      type: "regexp",
                                      pattern: new RegExp(/\d+/g),
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    style={{ width: "100%" }}
                                    placeholder="Value Of Contract"
                                    min={0}
                                  />
                                </Form.Item>

                                <Form.Item
                                  {...restField}
                                  label="Start date"
                                  name={[name, "startDate"]}
                                  labelCol={{ span: 6 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please select a start date",
                                    },
                                  ]}
                                >
                                  <DatePicker
                                    format={dateFormat}
                                    disabledDate={(current) =>
                                      current &&
                                      current < moment().startOf("day")
                                    }
                                    onChange={() => {
                                      // ✅ Reset endDate when startDate changes
                                      form.setFieldValue(
                                        [whichTab, name, "endDate"],
                                        null
                                      );
                                    }}
                                  />
                                </Form.Item>

                                <Form.Item
                                  {...restField}
                                  label="End date"
                                  name={[name, "endDate"]}
                                  labelCol={{ span: 6 }}
                                  dependencies={[[name, "startDate"]]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please select an end date",
                                    },
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        const startDate = getFieldValue([
                                          whichTab,
                                          name,
                                          "startDate",
                                        ]);
                                        if (
                                          !value ||
                                          !startDate ||
                                          value.isSameOrAfter(startDate, "day")
                                        ) {
                                          return Promise.resolve();
                                        }
                                        return Promise.reject(
                                          new Error(
                                            "End date must be greater than or equal to Start date"
                                          )
                                        );
                                      },
                                    }),
                                  ]}
                                >
                                  <DatePicker
                                    format={dateFormat}
                                    disabledDate={(current) => {
                                      const startDate = form.getFieldValue([
                                        whichTab,
                                        name,
                                        "startDate",
                                      ]);
                                      return (
                                        current &&
                                        (current < moment().startOf("day") ||
                                          (startDate &&
                                            current <
                                            moment(startDate).startOf("day")))
                                      );
                                    }}
                                  />
                                </Form.Item>

                                <Form.Item
                                  {...restField}
                                  label="Closing date"
                                  name={[name, "closeDate"]}
                                  labelCol={{ span: 6 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please select a closing date",
                                    },
                                  ]}
                                >
                                  <DatePicker
                                    format={dateFormat}
                                    disabledDate={(current) =>
                                      current &&
                                      current < moment().startOf("day")
                                    }
                                    onChange={() => {
                                      // ✅ Reset closing time when closing date changes
                                      form.setFieldValue(
                                        [whichTab, name, "closeTime"],
                                        null
                                      );
                                    }}
                                  />
                                </Form.Item>

                                <Form.Item
                                  {...restField}
                                  label="Closing time"
                                  name={[name, "closeTime"]}
                                  labelCol={{ span: 6 }}
                                  dependencies={[[name, "closeDate"]]} // re-run validator when closeDate changes
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please select a closing time",
                                    },
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        const closeDate = getFieldValue([
                                          whichTab,
                                          name,
                                          "closeDate",
                                        ]);
                                        if (!value || !closeDate) {
                                          return Promise.resolve();
                                        }
                                        // Ensure closing time is the same day as closing date or later
                                        if (
                                          moment(value).isSameOrAfter(
                                            moment(closeDate),
                                            "day"
                                          )
                                        ) {
                                          return Promise.resolve();
                                        }
                                        return Promise.reject(
                                          new Error(
                                            "Closing time must be on or after the closing date"
                                          )
                                        );
                                      },
                                    }),
                                  ]}
                                >
                                  <DatePicker
                                    showTime
                                    format={dateTimeFormat}
                                    disabledDate={(current) => {
                                      const closeDate = form.getFieldValue([
                                        whichTab,
                                        name,
                                        "closeDate",
                                      ]);
                                      return (
                                        current &&
                                        (current < moment().startOf("day") ||
                                          (closeDate &&
                                            current <
                                            moment(closeDate).startOf("day")))
                                      );
                                    }}
                                  />
                                </Form.Item>

                                <Form.Item
                                  {...restField}
                                  className="w-100"
                                  label="Contract Type"
                                  name={[name, "contractType"]}
                                  labelCol={{ span: 6 }}
                                >
                                  <Input placeholder="Contract Type" />
                                </Form.Item>
                                <Form.Item
                                  label="Web Link"
                                  {...restField}
                                  className="w-100"
                                  name={[name, "webLink"]}
                                  labelCol={{ span: 6 }}
                                >
                                  <Input
                                    placeholder="Web Link"
                                    name={[name, "webLink"]}
                                  />
                                </Form.Item>
                                <div className="d-flex">
                                  <Form.Item
                                    {...restField}
                                    className="w-100"
                                    name={[name, "mediaLink", "mediaType"]}
                                    label="Video or Image"
                                    labelCol={{ span: 6 }}
                                  >
                                    <Select
                                      name={[name, "mediaLink", "mediaType"]}
                                      onChange={(e) =>
                                        SelectChangeHandler(e, i)
                                      }
                                      placeholder="Select Option"
                                    >
                                      <Select.Option value="VIMEO_MEDIA">
                                        Add Vimeo Link
                                      </Select.Option>
                                      <Select.Option value="SOCIAL_MEDIA">
                                        Add Youtube Link
                                      </Select.Option>
                                      <Select.Option value="SYNTHESIA_MEDIA">
                                        Add Synthesia Link
                                      </Select.Option>
                                      <Select.Option value="IMAGE">
                                        Upload Image
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                  <Form.Item>
                                    <div className="remove-btn">
                                      <Tooltip
                                        title={
                                          "Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio"
                                        }
                                      >
                                        <QuestionCircleOutlined />
                                      </Tooltip>
                                    </div>
                                  </Form.Item>
                                </div>
                                {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                                  <Form.Item
                                    label="Youtube Link"
                                    {...restField}
                                    labelCol={{ span: 6 }}
                                    name={[name, "mediaLink", "url"]}
                                  >
                                    <Input placeholder="Youtube Link" />
                                  </Form.Item>
                                ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                                  <Form.Item
                                    label="Vimeo Link"
                                    labelCol={{ span: 6 }}
                                    {...restField}
                                    name={[name, "mediaLink", "url"]}
                                  >
                                    <Input placeholder="Vimeo Link" />
                                  </Form.Item>
                                ) : findValue(i, "type") === "IMAGE" ? (
                                  <Form.Item
                                    {...restField}
                                    label="Image"
                                    colon={false}
                                    name="media"
                                    className="experienceImg"
                                    labelCol={{ span: 6 }}
                                  >
                                    {findValue(i, "blob") ? (
                                      <Avatar
                                        src={URL.createObjectURL(
                                          findValue(i, "blob")
                                        )}
                                        alt=""
                                      />
                                    ) : findValue(i, "url") ? (
                                      <Avatar
                                        src={findValue(i, "url")}
                                        alt=""
                                      />
                                    ) : (
                                      <Avatar src={UserIcon} />
                                    )}

                                    <label
                                      name="file"
                                      className="fileUploadBtn greenBtn"
                                    >
                                      {" "}
                                      Choose File
                                      <input
                                        accept="image/png, image/gif, image/jpeg"
                                        type="file"
                                        // required={true}
                                        onChange={(e) =>
                                          updateImage(e, i, form, whichTab)
                                        }
                                      />
                                    </label>
                                  </Form.Item>
                                ) : findValue(i, "type") ===
                                  "SYNTHESIA_MEDIA" ? (
                                  <Form.Item
                                    label="Synthesia Link"
                                    labelCol={{ span: 6 }}
                                    {...restField}
                                    name={[name, "mediaLink", "url"]}

                                  >
                                    <Input />
                                  </Form.Item>
                                ) : null}

                                <Form.Item
                                  {...restField}
                                  className="w-100"
                                  label="Email"
                                  name={[name, "email"]}
                                  labelCol={{ span: 6 }}
                                  rules={[
                                    {
                                      type: "email",
                                      message: "Enter valid email",
                                    },
                                  ]}
                                >
                                  <Input placeholder="Email" />
                                </Form.Item>
                                <Form.Item
                                  className="w-100"
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                >
                                  {formChanged ? (
                                    <Button
                                      className="saveBtn greenBtn"
                                      onClick={() => {
                                        form.submit();
                                      }}
                                    >
                                      Save
                                    </Button>
                                  ) : (
                                    <Button
                                      className="saveBtn greenBtn"
                                      style={{
                                        opacity: "0.5",
                                        pointerEvents: "none",
                                      }}
                                    >
                                      Save
                                    </Button>
                                  )}
                                </Form.Item>
                              </Col>
                              <Col className="gutter-row tabContent" span={8}>
                                <div>
                                  {form.getFieldValue(whichTab)?.[i]
                                    ? renderMedia(
                                      form.getFieldValue(whichTab)[i]
                                    ) // ✅ form state is always in sync
                                    : null}
                                </div>
                              </Col>
                            </div>
                          );
                        })}
                      </>
                    )}
                  </Form.List>
                </>
              </Col>
            </>
          ) : (
            <></>
          )}
        </Row>
      </div>
    );
  }
}
